import { useCallback } from 'react'
import { ExamAttempt } from 'Types/Exams.types'

type UseExamTimeLimitProps = {
    timeLimitInSeconds?: number | null
    attempt?: ExamAttempt | null
}

export const useExamTimeLimit = ({ timeLimitInSeconds, attempt }: UseExamTimeLimitProps) => {
    const getTimeLeft = useCallback(() => {
        if (!timeLimitInSeconds) {
            return
        }
        if (!attempt) {
            return timeLimitInSeconds
        }
        const elapsedSeconds = (Date.now() - new Date(attempt.created_at).getTime()) / 1000
        return Math.max(0, Math.round(timeLimitInSeconds - elapsedSeconds))
    }, [attempt, timeLimitInSeconds])

    return { getTimeLeft, isTimeLimitSet: !!timeLimitInSeconds }
}
